module.exports = __webpack_public_path__ + "static/media/feature-public-data.6a156648.svg";